import { createFileRoute } from '@tanstack/react-router'
import { ProfilePage } from '@features/admin/profile'

export const Route = createFileRoute('/profile')({
  component: RouteComponent,
})

function RouteComponent() {
  return <ProfilePage />
}
